var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlayBadgeEs = function SvgGooglePlayBadgeEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "GooglePlayBadgeEs_svg__Layer_1",
    viewBox: "0 0 135 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GooglePlayBadgeEs_svg__linear-gradient",
    x1: 21.8,
    x2: 5.017,
    y1: 33.29,
    y2: 16.508,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GooglePlayBadgeEs_svg__linear-gradient-2",
    x1: 33.834,
    x2: 9.637,
    y1: 21.999,
    y2: 21.999,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GooglePlayBadgeEs_svg__linear-gradient-3",
    x1: 24.827,
    x2: 2.069,
    y1: 19.704,
    y2: -3.054,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GooglePlayBadgeEs_svg__linear-gradient-4",
    x1: 7.297,
    x2: 17.46,
    y1: 41.824,
    y2: 31.661,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("style", null, ".GooglePlayBadgeEs_svg__cls-3{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:.2px}.GooglePlayBadgeEs_svg__cls-6{opacity:.12;isolation:isolate}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130 .8c2.316 0 4.2 1.884 4.2 4.2v30c0 2.316-1.884 4.2-4.2 4.2H5A4.205 4.205 0 0 1 .8 35V5C.8 2.684 2.684.8 5 .8zm0-.8H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.752c-2.352 0-4.27 1.788-4.27 4.253 0 2.449 1.918 4.253 4.27 4.253s4.27-1.804 4.27-4.253c0-2.465-1.918-4.253-4.27-4.253m0 6.83c-1.289 0-2.4-1.063-2.4-2.577 0-1.53 1.111-2.578 2.4-2.578s2.4 1.047 2.4 2.578c0 1.514-1.111 2.577-2.4 2.577m-9.314-6.83c-2.352 0-4.269 1.788-4.269 4.253 0 2.449 1.917 4.253 4.27 4.253s4.269-1.804 4.269-4.253c0-2.465-1.917-4.253-4.27-4.253m0 6.83c-1.289 0-2.4-1.063-2.4-2.577 0-1.53 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.577-2.4 2.577m-11.078-5.525v1.804h4.317c-.129 1.015-.467 1.756-.982 2.272-.629.628-1.612 1.32-3.335 1.32-2.659 0-4.737-2.142-4.737-4.8s2.078-4.801 4.737-4.801c1.434 0 2.48.564 3.254 1.289l1.273-1.273c-1.08-1.031-2.513-1.82-4.527-1.82-3.641 0-6.702 2.964-6.702 6.605s3.06 6.605 6.702 6.605c1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.22 0-.42-.032-.806-.097-1.128zm45.308 1.401c-.355-.95-1.434-2.706-3.641-2.706-2.191 0-4.012 1.723-4.012 4.253 0 2.384 1.805 4.253 4.221 4.253 1.95 0 3.077-1.192 3.545-1.885l-1.45-.967c-.484.71-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.288l5.687-2.353zm-5.8 1.418c-.048-1.643 1.273-2.481 2.223-2.481.742 0 1.37.37 1.58.902zM82.628 30h1.87V17.498h-1.87zm-3.06-7.298h-.065c-.419-.5-1.224-.95-2.24-.95-2.126 0-4.075 1.868-4.075 4.269 0 2.384 1.95 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.87 2.498-2.271 2.498-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.19 0 4.044-1.289 4.044-4.43v-7.637h-1.773zm-2.143 5.88c-1.289 0-2.369-1.079-2.369-2.561 0-1.498 1.08-2.594 2.369-2.594 1.272 0 2.271 1.096 2.271 2.594 0 1.482-.999 2.561-2.271 2.561m24.38-11.083h-4.47V30H99.2v-4.736h2.606c2.068 0 4.101-1.498 4.101-3.883s-2.033-3.882-4.101-3.882m.049 6.025H99.2v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .97-.792 2.143-2.187 2.143m11.532-1.795c-1.351 0-2.75.595-3.33 1.913l1.657.692c.354-.692 1.013-.917 1.705-.917.965 0 1.946.58 1.962 1.609v.128c-.338-.193-1.062-.482-1.946-.482-1.785 0-3.603.98-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.255 0 1.946-.562 2.38-1.222h.065v.965h1.801v-4.793c0-2.219-1.656-3.457-3.795-3.457m-.226 6.851c-.61 0-1.463-.306-1.463-1.062 0-.964 1.061-1.334 1.978-1.334.82 0 1.206.177 1.705.418a2.26 2.26 0 0 1-2.22 1.978m10.583-6.578-2.139 5.42h-.064l-2.22-5.42h-2.01l3.33 7.575-1.899 4.214h1.946l5.131-11.789zM106.936 30h1.866V17.5h-1.866z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.435 7.538c-.29.308-.463.786-.463 1.405v22.116c0 .62.173 1.097.463 1.405l.074.072L22.9 20.147v-.292l-12.39-12.39z",
    style: {
      fill: "url(#GooglePlayBadgeEs_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.028 24.279-4.13-4.132v-.292l4.13-4.13.094.053 4.893 2.78c1.397.794 1.397 2.093 0 2.887l-4.893 2.78z",
    style: {
      fill: "url(#GooglePlayBadgeEs_svg__linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.122 24.225 22.898 20 10.435 32.464c.461.488 1.221.548 2.078.061z",
    style: {
      fill: "url(#GooglePlayBadgeEs_svg__linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.122 15.777-14.609-8.3c-.856-.487-1.617-.427-2.078.061l12.463 12.463z",
    style: {
      fill: "url(#GooglePlayBadgeEs_svg__linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.029 24.132-14.516 8.247c-.812.461-1.537.43-2.003.01l-.075.075.074.072c.466.42 1.192.451 2.004-.01l14.609-8.301z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.435 32.318c-.29-.308-.463-.785-.463-1.405v.146c0 .62.173 1.097.463 1.405l.075-.074zM32.015 21.299l-4.986 2.833.093.093 4.893-2.78c.698-.397 1.048-.92 1.048-1.444-.059.473-.415.938-1.048 1.298",
    className: "GooglePlayBadgeEs_svg__cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.513 7.623 19.502 11.08c.633.36.989.824 1.048 1.298 0-.523-.35-1.047-1.048-1.444L12.513 7.477c-1.397-.794-2.54-.134-2.54 1.466v.147c0-1.601 1.143-2.26 2.54-1.467",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.25
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.28 13V7h1.835q1.383 0 2.213.834.83.833.83 2.166t-.83 2.166q-.83.834-2.213.834zm.77-.737h1.065q1.038 0 1.647-.595.607-.595.607-1.668 0-1.065-.607-1.664-.608-.599-1.647-.599h-1.064zM47.24 13V7h.77v6zM51.076 13.134q-.653 0-1.277-.427a1.98 1.98 0 0 1-.818-1.199l.704-.284q.126.495.515.833.39.34.876.34.503 0 .86-.264a.85.85 0 0 0 .355-.717q0-.502-.356-.775-.356-.272-1.127-.507-.795-.25-1.207-.65-.41-.397-.41-1.018 0-.645.511-1.122.51-.478 1.332-.478.763 0 1.24.381.479.381.62.834l-.703.293q-.076-.285-.373-.528-.297-.242-.767-.243-.445 0-.758.248a.75.75 0 0 0-.315.615.7.7 0 0 0 .29.566q.29.23.85.415.444.142.742.277.298.133.603.356.306.221.46.553c.155.332.156.476.156.766s-.06.55-.18.78q-.18.344-.478.545a2.37 2.37 0 0 1-1.345.41ZM54.956 13h-.77V7h2.044q.763 0 1.32.507.558.507.557 1.278 0 .771-.557 1.277a1.9 1.9 0 0 1-1.32.508h-1.274zm0-3.168h1.291q.486 0 .78-.326.292-.327.292-.72c0-.394-.097-.504-.293-.721q-.293-.328-.779-.328h-1.291zM63.985 12.225q-.885.909-2.2.909t-2.2-.91q-.883-.908-.883-2.224c0-1.316.294-1.619.884-2.225q.883-.91 2.2-.91 1.307 0 2.195.914.888.915.888 2.221 0 1.316-.884 2.225Zm-3.83-.503q.666.675 1.63.675.965 0 1.63-.675.666-.675.667-1.722c0-1.047-.223-1.272-.667-1.722a2.2 2.2 0 0 0-1.63-.675q-.963 0-1.63.675-.665.675-.666 1.722c0 1.047.223 1.273.666 1.722ZM65.951 13V7h.939l2.916 4.668h.033l-.033-1.157V7h.771v6h-.805l-3.05-4.894h-.034l.034 1.157V13zM71.951 13V7h.77v6zM74.096 13V7h2.17q.704 0 1.22.465Q78 7.93 78 8.634q0 .427-.223.754a1.4 1.4 0 0 1-.59.495v.033q.443.15.729.52.285.368.285.855 0 .737-.541 1.223-.54.486-1.278.486zm.77-3.428h1.4q.436.001.7-.289.263-.288.263-.632c0-.344-.085-.44-.256-.628a.86.86 0 0 0-.673-.286h-1.434zm0 2.69h1.55a.92.92 0 0 0 .722-.31 1 1 0 0 0 .276-.679.97.97 0 0 0-.285-.674q-.285-.305-.746-.306h-1.517zM79.241 13V7h.77v5.263h2.598V13zM87.085 7.737h-2.733V9.64h2.464v.72h-2.464v1.903h2.733V13h-3.503V7h3.503zM93.806 7.737h-2.733V9.64h2.464v.72h-2.464v1.903h2.733V13h-3.503V7h3.503zM95.012 13V7h.938l2.916 4.668h.033l-.033-1.157V7h.772v6h-.805l-3.05-4.894h-.034l.033 1.157V13z",
    className: "GooglePlayBadgeEs_svg__cls-3"
  })));
};
export { SvgGooglePlayBadgeEs as ReactComponent };
export default __webpack_public_path__ + "static/GooglePlayBadgeEs.ee28b59e.svg";